
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.MemberEntitlementManagement.WebApi.Internal
//----------------------------------------------------------


export module ErrorCodes {
    export const General = 5000;
    export const IdentityNotFound = 5001;
    export const InvalidIdentity = 5002;
    export const InvalidProjectId = 5003;
    export const RemoveUserFromAccountError = 5004;
    export const AssignedLicenseFailed = 5005;
    export const AssignedExtensionFailed = 5006;
    export const UnassignExtensionFailed = 5007;
    export const UnsupportedOperation = 5008;
    export const RemoveIdentityFromSecurityGroupError = 5009;
    export const GroupDoesNotExist = 5010;
    export const MultipleErrors = 5011;
    export const LicenseTypeConversionError = 5012;
    export const ExportCSVFailed = 5013;
    export const MemberNotInProject = 5014;
    export const NotEnoughLicenses = 5015;
    export const CannotDowngradeAccountAdmin = 5016;
    export const InvalidLicenseType = 5017;
    export const ExtensionUnassignable = 5018;
    export const InvalidMemberEntitlement = 5019;
    export const GroupAddJobFailed = 5020;
    export const GroupRemoveOperationFailed = 5021;
    export const GroupCreationFailed = 5022;
    export const IdentityGetOrCreateError = 5023;
    export const GroupGetOrCreateError = 5024;
    export const InvalidGroupDisplayName = 5025;
    export const InvalidGroupId = 5026;
    export const GroupApplyAllOperationFailed = 5028;
    export const GroupUpdateOperationFailed = 5029;
    export const InvalidTeamId = 5030;
    export const TeamsApiUnavailable = 5031;
    export const AccessDenied = 5032;
    export const InvalidEmail = 5033;
    export const CannotChangeGroupAssignment = 5034;
    export const NotEnoughExtensionLicenses = 5035;
    export const SendInviteFailed = 5036;
    export const BuildGroupEntitlementFailed = 5037;
    export const BuildUserEntitlementFailed = 5038;
    export const RemoveDirectAssignmentsForNewGroupMemebersFailed = 5039;
    export const UserEntitlementNotFound = 5040;
    export const NoMeterUsageReturned = 5041;
    export const UnsupportedMemberEntitlement = 5042;
    export const ExternalGuestAccessDenied = 5101;
    export const GuestAadInviteGenericFailure = 5102;
    export const GuestUserInviterError = 5103;
    export const GuestUsersNotAllowedToPerfomAction = 5104;
    export const InviteeHasSameDomain = 5105;
    export const ValidRefreshTokenNotFound = 5106;
    export const GuestUserBadRequest = 5107;
    export const MemberAlreadyInProject = 6001;
    export const SkippedAddInvalidGroup = 6002;
    export const CannotCreateProjectLevelGroup = 6003;
}

export module ExceptionTypeKeys {
    export const UserManagementException = "UserManagementException";
    export const MemberNotFoundException = "UserNotFoundException";
    export const AccountAdminDowngradeLicenseException = "AccountAdminDowngradeLicenseException";
    export const ChangeGroupAssignmentNotAllowedException = "ChangeGroupAssignmentNotAllowedException";
    export const ExtensionUnassignableException = "ExtensionUnassignableException";
    export const AssignLicenseNotAvailableException = "AssignLicenseNotAvailableException";
    export const AssignExtensionsErrorException = "AssignExtensionsErrorException";
    export const AssignExtensionLicenseNotAvailableException = "AssignExtensionLicenseNotAvailableException";
}

export module UsersSummaryPropertyNames {
    export const Projects = "projects";
    export const Groups = "groups";
    export const Licenses = "licenses";
    export const AccessLevels = "accesslevels";
    export const DefaultAccessLevel = "defaultAccessLevel";
}

